import { Datatype, PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorNotDefinedType = createConditionOperator({
  code: 'notDefined',
  label: 'non definito',
  description: 'Non definito',
  args: [],
  allowsField: field =>
    PlainDatatypes.includes(field.type) || field.type === Datatype.File,
  compare(value: any) {
    return value == null || (typeof value === 'string' && value.trim() === '');
  },
});
